export const sponsorsLink = "https://fda888.feida36588.com/index";

export const lineLink = "https://lin.ee/Tq0ILiq";
